interface Config {
    baseURL: string;
    timeout: number;
}

const config: Config = {
    baseURL: process.env.VUE_APP_BASE_API!,
    timeout: 8000,
};

export { config,  Config};
